import { Fragment, useEffect, useId, useRef, useState } from "react";
import { useGlobalFunction } from "../../../Context/GlobalFunctionContext";
import { PriceBreakupTable } from "./priceBreakupTable";

export const PriceTablePopup = ({ params, mode = 1, stockStatus = null, popperConfig = null }) => {
  const toggleId = `proPricing${useId().replace(/:/g, "")}`;
  const [priceData, setPriceData] = useState(null);
  const [stockData, setStockData] = useState(null);
  const { GetPriceTableData } = useGlobalFunction();
  const prevValue = useRef();
  useEffect(() => {
    if (params.productId && params.productCode) {
      if (prevValue.current != params) {
        prevValue.current = params;
        // fetchPriceData();
      }
    }
  }, [params]);

  useEffect(() => {
    if (stockStatus) setStockData(stockStatus);
  }, [stockStatus]);

  const fetchPriceData = async () => {
    const data = await GetPriceTableData(prevValue.current.productId, prevValue.current.productCode);
    setPriceData(data);
  };
  return (
    <div className="dropdown proList-dropdown">
      {mode === 1 ? (
        <div
          className="dropdown-toggle wes-dollar"
          id={toggleId}
          data-bs-toggle="dropdown"
          aria-expanded="false"
          data-bs-auto-close="outside"
          onClick={fetchPriceData}
          onMouseEnter={fetchPriceData}
        />
      ) : (
        <div
          className="dropdown-toggler"
          id={toggleId}
          data-bs-toggle="dropdown"
          data-bs-popper-config={popperConfig ? JSON.stringify(popperConfig) : undefined}
          aria-expanded="false"
          onClick={fetchPriceData}
          onMouseEnter={fetchPriceData}
        >
          <a role="button" className="text-link fs-13">
            Price/Stock Status
          </a>
        </div>
      )}
      <PriceBreakupTable data={priceData} labelledBy={toggleId} stockStatus={stockData} />
    </div>
  );
};
